import { Link, Text } from '@podiumhq/design-system';

import { useTrialsContext } from 'contexts/TrialsContextProvider';

const SuggestedEmailMessage = ({
  color = '#373e41',
  handleEmailSuggestion,
  suggestedEmail,
  ...props
}) => {
  const { email, setEmail } = useTrialsContext() || {};

  const onHandleSuggestion = (event) => {
    event.preventDefault();
    handleEmailSuggestion(email, setEmail);
  };

  return !!suggestedEmail ? (
    <Text color={color} fontSize="sm" fontWeight="normal" {...props}>
      Did you mean
      <Link ml="6px" onClick={onHandleSuggestion} textDecoration="underline">
        {suggestedEmail}
      </Link>
    </Text>
  ) : null;
};

export default SuggestedEmailMessage;
